// A safety ceiling rejects the whole load, never silently truncates the picker.
const MAX_PAGES = 1000;

// Fetch atomically: callers receive a complete list, never intermediate pages.
export async function loadPrograms(getPage) {
  const programs = new Map();
  let snapshot;
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const data = await getPage(page);
    const legacy = Array.isArray(data);
    const items = legacy ? data : data?.items;
    if (!Array.isArray(items) || items.some(program =>
      !program || typeof program.program_id !== 'string' || !program.program_id.trim()
    )) throw new Error('Invalid programs response');
    if (legacy && page !== 1) throw new Error('Programs response changed during pagination');
    if (!legacy) {
      const { total, page_size: size, total_pages: pages, has_next: next, has_prev: prev } = data;
      if (!Number.isSafeInteger(total) || total < 0 ||
          !Number.isSafeInteger(size) || size < 1 || size > 100 ||
          !Number.isSafeInteger(pages) || pages < 1 || pages > MAX_PAGES ||
          pages !== Math.max(1, Math.ceil(total / size)) || data.page !== page ||
          next !== (page < pages) || prev !== (page > 1) ||
          items.length !== Math.min(size, total - (page - 1) * size) ||
          (snapshot && (total !== snapshot.total || size !== snapshot.size || pages !== snapshot.pages))) {
        throw new Error('Inconsistent or excessive program pagination');
      }
      snapshot = { total, size, pages };
    }
    items.forEach(program => programs.set(program.program_id, program));
    if (legacy || page === snapshot.pages) {
      // Offset paging can overlap under concurrent writes. Dedupe by canonical ID,
      // but do not call a snapshot complete if that overlap omitted a program.
      if (!legacy && programs.size !== snapshot.total) throw new Error('Incomplete program pagination; retry');
      return [...programs.values()];
    }
  }
  throw new Error('Program pagination limit exceeded');
}
